import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";

const HERO = "https://images.pexels.com/photos/1235706/pexels-photo-1235706.jpeg";
const LIFE = "https://images.pexels.com/photos/38217301/pexels-photo-38217301.jpeg";
const BEANS = "https://images.unsplash.com/photo-1447933601403-0c6688de566e";
const MARBLE = "https://images.pexels.com/photos/34531681/pexels-photo-34531681.jpeg";

const CHAPTERS = [
  {
    n: "01",
    t: "Selecția",
    d: "Alegem doar loturi de cafea boabe de la brandurile pe care le iubim și în care avem încredere. Fiecare sortiment trece printr-o degustare atentă înainte de a ajunge în catalog.",
    img: BEANS,
  },
  {
    n: "02",
    t: "Păstrarea",
    d: "Cafeaua este depozitată în condiții atent controlate, ferită de factorii care îi pot afecta prospețimea și aroma. Respectăm fiecare produs de la intrarea în depozit până în momentul pregătirii comenzii.",
    img: LIFE,
  },
  {
    n: "03",
    t: "Livrarea",
    d: "Ambalăm sigilat pentru prospețime maximă și livrăm rapid în toată țara. De la depozitul nostru direct în ceașca ta, în doar câteva zile.",
    img: MARBLE,
  },
];

export default function About() {
  useEffect(() => window.scrollTo(0, 0), []);
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);

  return (
    <div>
      <section ref={ref} className="relative h-[80svh] min-h-[520px] overflow-hidden bg-ink">
        <motion.img style={{ y }} src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/60 to-ink/90" />
        <div className="relative z-10 h-full max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col justify-end pb-20">
          <p className="overline text-sand mb-5">Despre noi</p>
          <h1 className="font-display text-cream text-6xl md:text-8xl tracking-tight">
            <MaskedLines lines={["Povestea din", "spatele ceștii."]} delay={0.2} />
          </h1>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <Reveal>
          <p className="font-display text-3xl md:text-5xl leading-[1.15] tracking-tight max-w-4xl">
            La Coffee Cup Supply credem că o cafea bună nu este un lux, ci un ritual de zi cu zi.
            De aceea aducem cele mai apreciate branduri direct la tine acasă.
          </p>
        </Reveal>
      </section>

      {CHAPTERS.map((c, i) => (
        <section key={c.n} className={`${i % 2 === 1 ? "bg-stone" : ""}`}>
          <div className={`max-w-[1400px] mx-auto px-5 md:px-10 py-20 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
            <Reveal className="lg:[direction:ltr]">
              <div className="overflow-hidden aspect-[4/3] bg-stone">
                <img src={c.img} alt={c.t} className="h-full w-full object-cover" />
              </div>
            </Reveal>
            <Reveal delay={0.1} className="lg:[direction:ltr]">
              <span className="font-display text-8xl md:text-9xl text-sand/50 leading-none">{c.n}</span>
              <h2 className="font-display text-4xl md:text-6xl tracking-tight mt-2">{c.t}</h2>
              <p className="text-muted-foreground leading-relaxed mt-6 max-w-md">{c.d}</p>
            </Reveal>
          </div>
        </section>
      ))}

      <section className="bg-ink text-cream">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 text-center">
          <Reveal>
            <h2 className="font-display text-4xl md:text-7xl tracking-tight">Simte diferența în fiecare ceașcă.</h2>
            <Link to="/produse" data-testid="about-cta" className="group inline-flex items-center gap-3 mt-10 bg-cream text-ink px-9 py-4 hover:bg-sand transition-colors duration-300">
              <span className="text-sm font-semibold tracking-wide">Explorează colecția</span>
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
